/* Dominion Watch Co. — original storefront interactions, October 2026. */
(() => {
  const syncHeader = () => {
    const group = document.getElementById('header-group');
    if (!group) return;
    document.body.style.setProperty('--header-group-height', `${group.getBoundingClientRect().height}px`);
    const header = document.getElementById('dw-header');
    document.body.style.setProperty('--header-height', `${header?.getBoundingClientRect().height || 80}px`);
  };
  syncHeader();
  if ('ResizeObserver' in window) {
    const header = document.getElementById('header-group');
    if (header) new ResizeObserver(syncHeader).observe(header);
  }
  document.addEventListener('shopify:section:load', syncHeader);
  if (!customElements.get('dw-menu')) customElements.define('dw-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-dw-menu-open]');
      if (!this.dialog || !this.trigger) return;
      this.trigger.addEventListener('click', () => {
        this.savedOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      }, options);
      this.querySelector('[data-dw-menu-close]')?.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX > rect.right || event.clientY > rect.bottom || event.clientX < rect.left) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = this.savedOverflow || '';
        this.trigger.focus();
      }, options);
      window.addEventListener('resize', () => { if (innerWidth >= 1100 && this.dialog.open) this.dialog.close(); }, options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.savedOverflow || ''; }
      this.abort?.abort();
    }
  });
  if (!customElements.get('dw-faq-search')) customElements.define('dw-faq-search', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.querySelector('[data-dw-faq-search]')?.addEventListener('input', event => {
        const term = event.target.value.trim().toLowerCase(); let found = 0;
        this.querySelectorAll('[data-dw-question]').forEach(item => {
          const match = item.textContent.toLowerCase().includes(term);
          item.hidden = !match; if (match) found++;
        });
        const empty = this.querySelector('[data-dw-faq-empty]'); if (empty) empty.hidden = found > 0;
        const status = this.querySelector('[data-dw-faq-status]'); if (status) status.textContent = `${found} answers found`;
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-dw-track-form]')) return;
    const input = form.querySelector('[name="nums"]');
    event.preventDefault();
    if (!input) return;
    input.value = input.value.trim();
    const value = input.value;
    if (!form.reportValidity()) return;
    const url = `https://t.17track.net/en#nums=${encodeURIComponent(value)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  });
})();
